import * as React from "react"
import {Divider, List, ListItem, ListItemButton, ListItemText} from "@mui/material"

import {CATALOGUE_ROUTES, DIGITAL_SHELF_ROUTES, MARKETPLACES_ROUTES, PRICING_ROUTES, REPRICING_ROUTES, STOCK_ROUTES} from "@constants"
import {useRoutesApp} from "@hooks";
import {contentType} from "../@signals";
import {CONTENT_TYPE} from "../constants";


export default function InfoCenterAccordionMenu() {
    const { accessibleSections } = useRoutesApp()
    return <List>
        <ListItem disablePadding>
            <ListItemButton 
                onClick={() => contentType.value = CONTENT_TYPE.BASIC_FUNCTIONS} 
                sx={{bgcolor: contentType.value === CONTENT_TYPE.BASIC_FUNCTIONS ? 'primary.light' : 'transparent'}}
            >
                <ListItemText primary="Basic Functions"/>
            </ListItemButton>
        </ListItem> 
        { accessibleSections.includes(PRICING_ROUTES.ACCESS_KEY) && <>
            <Divider />
            <ListItem disablePadding>
                <ListItemButton 
                    onClick={() => contentType.value = CONTENT_TYPE.PRICING}
                    sx={{bgcolor: contentType.value === CONTENT_TYPE.PRICING ? 'primary.light' : 'transparent'}} 
                >
                    <ListItemText primary="Pricing"/>
                </ListItemButton>
        </ListItem></> }

        { accessibleSections.includes(REPRICING_ROUTES.ACCESS_KEY) && <>
            <Divider />
            <ListItem disablePadding>
                <ListItemButton 
                    onClick={() => contentType.value = CONTENT_TYPE.REPRICING}
                    sx={{bgcolor: contentType.value === CONTENT_TYPE.REPRICING ? 'primary.light' : 'transparent'}}
                >
                    <ListItemText primary="Repricing"/>
                </ListItemButton>
            </ListItem>
        </> }

        { accessibleSections.includes(DIGITAL_SHELF_ROUTES.ACCESS_KEY) && <>
            <Divider />
            <ListItem disablePadding>
                <ListItemButton 
                    onClick={() => contentType.value = CONTENT_TYPE.DIGITAL_SHELF}
                    sx={{bgcolor: contentType.value === CONTENT_TYPE.DIGITAL_SHELF ? 'primary.light' : 'transparent'}}
                >
                    <ListItemText primary="Digital Shelf"/>
                </ListItemButton>
            </ListItem>
        </> }

        { accessibleSections.includes(CATALOGUE_ROUTES.ACCESS_KEY) && <>
            <Divider />
            <ListItem disablePadding>
                <ListItemButton 
                    onClick={() => contentType.value = CONTENT_TYPE.CATALOGUE}
                    sx={{bgcolor: contentType.value === CONTENT_TYPE.CATALOGUE ? 'primary.light' : 'transparent'}}
                >
                    <ListItemText primary="Catalogue"/>
                </ListItemButton>
            </ListItem>
        </> }

        { accessibleSections.includes(MARKETPLACES_ROUTES.ACCESS_KEY) && <>
            <Divider />
            <ListItem disablePadding>
                <ListItemButton 
                    onClick={() => contentType.value = CONTENT_TYPE.MARKETPLACES}
                    sx={{bgcolor: contentType.value === CONTENT_TYPE.MARKETPLACES ? 'primary.light' : 'transparent'}}
                >
                    <ListItemText primary="Marketplaces"/>
                </ListItemButton>
            </ListItem>
        </> }

        { accessibleSections.includes(STOCK_ROUTES.ACCESS_KEY) && <>
            <Divider />
            <ListItem disablePadding>
                <ListItemButton 
                    onClick={() => contentType.value = CONTENT_TYPE.STOCK}
                    sx={{bgcolor: contentType.value === CONTENT_TYPE.STOCK ? 'primary.light' : 'transparent'}}
                >
                    <ListItemText primary="Stock"/>
                </ListItemButton>
            </ListItem>
        </> }

        
    </List>
}